import { useList } from "@inmagik/react-crud"
import { API_URL } from "../../constants"
import { Servizio } from "../../types"

export function useServizioList(params: Record<string, string> = {}) {
  return useList<Servizio>(`${API_URL}/servizi`, { query: params })
}
